<template>
  <form @submit.prevent="goNext">
    <LoadingPlugin
      :active.sync="isLoading"
      :is-full-page="fullPage"
      background-color="#f3f3f3"
      :opacity="0.8"
      loader="bars"
    ></LoadingPlugin>
    <SuccessModal
      :show="showSuccessPopup"
      @close="closeSuccess"
      :msg="$t('success_msg_alarm_create')"
      :heading="$t('success_heading_alarm_create')"
    />

    <div class="add-alarm">
      <div v-if="step === 1">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <h6 class="font-14 font-weight-bold">
            {{ $t("add_alarms") }}
          </h6>

          <div class="d-flex align-items-center mb-3">
            <input type="checkbox" v-model="notifyWhenNormal" />
            <p class="gray4 ml-2">
              {{ $t("notif_when_back_to_normal") }}
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-sm-6">
            <div class="form-group">
              <label>{{ $t("alarm_name") }}</label>
              <input
                type="text"
                name="name"
                v-model="title"
                :placeholder="$t('enter_alarm_name')"
                class="form-control"
                required
              />
            </div>

            <div class="form-group">
              <label>{{ $t("temp_value") }} {{ $t("optional") }}</label>
              <div class="d-flex col-gap-1 justify-content-between">
                <input
                  type="number"
                  name="name"
                  v-model.number="temperature.min"
                  class="form-control"
                  :required="isRequiredField(temperature.max)"
                  :placeholder="$t('enter_min_temp')"
                />

                <input
                  type="number"
                  name="name"
                  v-model.number="temperature.max"
                  class="form-control"
                  :required="isRequiredField(temperature.min)"
                  :placeholder="$t('enter_max_temp')"
                />
              </div>
            </div>

            <div class="form-group">
              <label>{{ $t("battery_value") }} {{ $t("optional") }}</label>
              <div class="d-flex col-gap-1 justify-content-between">
                <input
                  type="number"
                  min="0"
                  name="name"
                  v-model.number="battery.min"
                  class="form-control"
                  :required="isRequiredField(battery.max)"
                  :placeholder="$t('enter_min_battery')"
                />

                <input
                  type="number"
                  name="name"
                  max="100"
                  v-model.number="battery.max"
                  class="form-control"
                  :required="isRequiredField(battery.min)"
                  :placeholder="$t('enter_max_battery')"
                />
              </div>
            </div>

            <div class="form-group">
              <label>{{ $t("geo") }} {{ $t("optional") }}</label>
              <!-- <input
              type="text"
              name="name"
              v-model="geofenceData.id"
              class="form-control"
              required
            /> -->
              <select name="id" class="form-control" v-model="geofenceData.id">
                <option value="">
                  {{ $t("select") }}
                </option>
                <option
                  v-for="data in geofence"
                  :key="data.id"
                  :value="data.id"
                >
                  {{ data.name }}
                </option>
              </select>

              <div class="d-flex col-gap-2 align-items-center mt-2">
                <div class="d-flex align-items-center">
                  <input type="checkbox" v-model="geofenceData.notifyWhenIn" />
                  <p class="gray4 ml-2">
                    {{ $t("notif_when_in_geo") }}
                  </p>
                </div>
                <div class="d-flex align-items-center">
                  <input type="checkbox" v-model="geofenceData.notifyWhenOut" />
                  <p class="gray4 ml-2">
                    {{ $t("notif_when_out_geo") }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="form-group">
            <div class="d-flex col-gap-1 justify-content-between">
              <label>{{ $t("delay_alarm") }} </label>

              <select name="id" class="form-control" v-model="geofenceData.id">
                <option value="">
                  {{ $t("select_day") }}
                </option>
                <option
                  v-for="option in delay"
                  :key="option.id"
                  :value="option.value"
                >
                  {{ option.label }}
                </option>
              </select>

              <div class="d-flex col-gap-2 align-items-center mt-2">
                <div class="d-flex align-items-center">
                  <input type="checkbox" v-model="geofenceData.notifyWhenIn" />
                  <p class="gray4 ml-2">
                    {{ $t("notif_when_in_geo") }}
                  </p>
                </div>
                <div class="d-flex align-items-center">
                  <input type="checkbox" v-model="geofenceData.notifyWhenOut" />
                  <p class="gray4 ml-2">
                    {{ $t("notif_when_out_geo") }}
                  </p>
                </div>
              </div>
            </div>
            <div class="d-flex col-gap-1 justify-content-between">
              <label>{{ $t("delay_alarm") }} </label>

              <select name="id" class="form-control" v-model="geofenceData.id">
                <option value="">
                  {{ $t("select_day") }}
                </option>
                <option
                  v-for="option in delay"
                  :key="option.id"
                  :value="option.value"
                >
                  {{ option.label }}
                </option>
              </select>

              <div class="d-flex col-gap-2 align-items-center mt-2">
                <div class="d-flex align-items-center">
                  <input type="checkbox" v-model="geofenceData.notifyWhenIn" />
                  <p class="gray4 ml-2">
                    {{ $t("notif_when_in_geo") }}
                  </p>
                </div>
                <div class="d-flex align-items-center">
                  <input type="checkbox" v-model="geofenceData.notifyWhenOut" />
                  <p class="gray4 ml-2">
                    {{ $t("notif_when_out_geo") }}
                  </p>
                </div>
              </div>
            </div>
          </div> -->

          <div class="col-12 col-sm-6">
            <!-- <div class="form-group">
          
          </div> -->
            <div class="form-group">
              <label>{{ $t("delay_alarm") }} </label>
              <div class="d-flex col-gap-1 justify-content-between">
                <select name="alarm-delay" class="form-control" v-model="delay">
                  <option value="" disabled>
                    {{ $t("select_delay") }}
                  </option>
                  <option
                    v-for="option in delayOptions"
                    :key="option.id"
                    :value="option.value"
                  >
                    {{ option.label }}
                  </option>
                </select>
                <select
                  name="device"
                  class="form-control"
                  v-model="delayValue"
                  required
                >
                  <option value="" disabled selected>
                    {{
                      $t(
                        delay === "time"
                          ? "select_time"
                          : delay === "frequency"
                          ? "select_freq"
                          : "select_time_freq"
                      )
                    }}
                  </option>
                  <option
                    v-for="{ label, value } in getDelayOptions"
                    :key="value"
                    :value="value"
                  >
                    {{ label }}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-group">
              <label>{{ $t("humid_value") }} {{ $t("optional") }}</label>
              <div class="d-flex col-gap-1 justify-content-between">
                <input
                  type="number"
                  name="name"
                  min="0"
                  v-model.number="humidity.min"
                  class="form-control"
                  :required="isRequiredField(humidity.max)"
                  :placeholder="$t('enter_min_humid')"
                />

                <input
                  type="number"
                  name="name"
                  v-model.number="humidity.max"
                  class="form-control"
                  :required="isRequiredField(humidity.min)"
                  :placeholder="$t('enter_max_humid')"
                />
              </div>
            </div>
            <div class="form-group">
              <label>{{ $t("lux") }} {{ $t("optional") }}</label>
              <div class="d-flex col-gap-1 justify-content-between">
                <input
                  type="number"
                  name="min_lux"
                  min="0"
                  v-model.number="lux.min"
                  class="form-control"
                  :required="isRequiredField(lux.max)"
                  :placeholder="$t('enter_min_lux')"
                />

                <input
                  type="number"
                  name="max_lux"
                  v-model.number="lux.max"
                  :required="isRequiredField(lux.min)"
                  class="form-control"
                  :placeholder="$t('enter_max_lux')"
                />
              </div>
            </div>
            <div class="form-group">
              <label>{{ $t("POI") }} {{ $t("optional") }} </label>
              <select name="poi" class="form-control" v-model="poiData.id">
                <option value="">
                  {{ $t("select") }}
                </option>
                <option v-for="data in POI" :key="data.id" :value="data.id">
                  {{ data.name }}
                </option>
              </select>

              <div class="d-flex col-gap-2 align-items-center mt-2">
                <div class="d-flex align-items-center">
                  <input type="checkbox" v-model="poiData.notifyWhenIn" />
                  <p class="gray4 ml-2">
                    {{ $t("notif_when_in_poi") }}
                  </p>
                </div>
                <div class="d-flex align-items-center">
                  <input type="checkbox" v-model="poiData.notifyWhenOut" />
                  <p class="gray4 ml-2">
                    {{ $t("notif_when_out_poi") }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="grid-card" v-if="step === 2">
        <ComboBox
          :data="sorteddevices"
          prefix="devices"
          :isItemChecked="
            (device) => selecteddevices.map(({ id }) => id).includes(device.id)
          "
          @checkClick="(device) => updateDevice(device)"
          @doSearch="doSearch"
          :isSelectAll="selecteddevices.length === allSortedDevices.length"
          :selectAll="
            () =>
              (selecteddevices = allSortedDevices.map(
                ({ imei, id, settings }) => ({
                  imei: imei,
                  deviceName: settings.name,
                  id: id,
                })
              ))
          "
          :deSelectAll="() => (selecteddevices = [])"
          :label="$t('add_devices')"
          :errorMessage="
            errors.includes('devices') ? 'Pls select at least one device' : ''
          "
        />
        <div class="form-group">
          <label>{{ $t("webhook") }}</label>
          <input
            type="text"
            name="name"
            v-model="webhook"
            class="form-control"
            :placeholder="$t('enter_webhook')"
          />
          <div v-if="errors.includes('webhook')" class="error">
            This needs to be a valid url
          </div>
        </div>

        <div class="form-group">
          <label>
            {{ $t("mode_of_alarm") }}
          </label>
          <select
            id="mode-of-alarm"
            v-model="modeOfAlarm"
            name="mode-of-alarm"
            class="form-control"
          >
            <option value="" disabled selected>
              {{ $t("select_mode") }}
            </option>
            <option
              v-for="{ label, value } in modeOfAlarmOptions"
              :key="value"
              :value="value"
            >
              {{ label }}
            </option>
          </select>
          <div v-if="errors.includes('modeOfAlarm')" class="error">
            Pls select a mode of alarm
          </div>
        </div>

        <ComboBox
          :data="getUsersForModeOfAlarm"
          prefix="users"
          :isItemChecked="
            (user) => selectedusers.map(({ id }) => id).includes(user.id)
          "
          @checkClick="(user) => updateUser(user)"
          @doSearch="doSearchUser"
          :isSelectAll="getUsersForModeOfAlarm.length === selectedusers.length"
          :selectAll="
            () =>
              (selectedusers = getUsersForModeOfAlarm.map(({ value, id }) => ({
                value,
                id,
              })))
          "
          :deSelectAll="() => (selectedusers = [])"
          :label="$t('add_users_staff_email')"
          :isDisabled="!modeOfAlarm"
          :selected="selectedusers"
          :showValues="true"
          @removeItem="removeASelectedUser"
          :errorMessage="
            errors.includes('users') ? 'Pls select at least one user' : ''
          "
        />
        <div class="level-checkbox">
          <input
            type="checkbox"
            :checked="showLevel"
            name="showLevel"
            @input="handleShowLevel"
            id="show-level"
          />
          <label for="show-level" htmlFor="showLevel">{{
            $t("add_escalation_tree")
          }}</label>
        </div>
        <div class="levels" v-if="showLevel">
          <div class="line-divider"></div>

          <div
            class="d-flex justify-content-between align-items-center mt-3 mb-3"
          >
            <span class="add-header">{{ $t("add_escalation_tree") }}</span>

            <button
              class="add-btn"
              @click="addLevel"
              type="button"
              v-if="levels.length < 3"
            >
              <span>+</span>
              <span>Add Level</span>
            </button>
          </div>

          <div v-for="level in levels" :key="level.id">
            <div class="level-row">
              <div class="d-flex col-gap-1 justify-content-between">
                <div class="form-group w-50">
                  <label>
                    {{ $t("mode_of_alarm") }}
                  </label>
                  <select
                    id="mode-of-alarm"
                    name="mode-of-alarm"
                    class="form-control"
                    @input="handleLevelInput($event, level)"
                    :value="level.modeOfAlarm"
                  >
                    <option value="" disabled selected>
                      {{ $t("select_mode") }}
                    </option>
                    <option
                      v-for="{ label, value } in modeOfAlarmOptions"
                      :key="value"
                      :value="value"
                    >
                      {{ label }}
                    </option>
                  </select>
                  <div
                    v-if="level.errors.includes('modeOfAlarm')"
                    class="error"
                  >
                    Pls select a mode of alarm
                  </div>
                </div>
                <div class="form-group w-50">
                  <label>
                    {{ $t("time_int") }}
                  </label>
                  <select
                    id="time-interval"
                    name="time-interval"
                    class="form-control"
                    @input="handleLevelInput($event, level)"
                    :value="level.levelTimeInterval"
                  >
                    <option value="" disabled selected>
                      {{ $t("select_time") }}
                    </option>
                    <option
                      v-for="{ label, value } in timeInterval"
                      :key="value"
                      :value="value"
                    >
                      {{ label }}
                    </option>
                  </select>
                  <div v-if="level.errors.includes('time')" class="error">
                    Pls select a time interval
                  </div>
                </div>
              </div>
              <ComboBox
                prefix="escalation-level-users"
                :data="getUsersForLevel(level)"
                :isItemChecked="
                  (user) =>
                    level.levelselectedusers
                      .map(({ id }) => id)
                      .includes(user.id)
                "
                @checkClick="(user) => updateLevelUsers(user, level)"
                @doSearch="doSearchUser"
                :selectAll="() => selectAllUsersForLevel(level)"
                :deSelectAll="() => deSelectAllUsersForLevel(level)"
                :label="$t('add_users_staff_email')"
                :isDisabled="!level.modeOfAlarm"
                :selected="level.levelselectedusers"
                :showValues="true"
                @removeItem="
                  (userId) => removeASelectedLevelUser(userId, level)
                "
                :isSelectAll="users.length === level.levelselectedusers.length"
                :errorMessage="
                  level.errors.includes('users')
                    ? 'Pls select at least one user'
                    : ''
                "
              />
              <button
                class="delete"
                @click="removeLevel(level.id)"
                :class="{ 'move-up': level.errors.length > 0 }"
              >
                <img src="./../../assets/images/delete.svg" alt="delete" />
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="step-3 row" v-if="step === 3">
        <div class="step-3-col">
          <div class="d-flex justify-content-between">
            <h3 class="step-3-heading">{{ $t("alarm_details") }}</h3>
            <span @click="$emit('step', 1)">
              <AlarmEditIcon />
            </span>
          </div>
          <div class="step__3--card mb-2">
            <div>
              <span class="gray4"> {{ $t("alarm_name") }}</span>
              <span>{{ title }}</span>
            </div>
            <div>
              <span class="gray4"> {{ $t("delay_alarm") }}</span>
              <span>
                {{ getDelayUnit }}
              </span>
            </div>
          </div>
          <div class="step__3--card mb-2">
            <div v-if="temperature.min">
              <span class="gray4"> {{ $t("min-temp") }}</span>
              <span>{{ temperature.min }}°C</span>
            </div>
            <div v-if="temperature.max">
              <span class="gray4"> {{ $t("max-temp") }}</span>
              <span>{{ temperature.max }}°C</span>
            </div>
            <div v-if="humidity.min">
              <span class="gray4"> {{ $t("min-humid") }}</span>
              <span>{{ humidity.min }}%</span>
            </div>
            <div v-if="humidity.max">
              <span class="gray4"> {{ $t("max-humid") }}</span>
              <span>{{ humidity.max }}%</span>
            </div>
            <div v-if="lux.min">
              <span class="gray4"> {{ $t("min-lux") }}</span>
              <span>{{ lux.min }}%</span>
            </div>
            <div v-if="lux.max">
              <span class="gray4"> {{ $t("max-lux") }}</span>
              <span>{{ lux.max }}%</span>
            </div>
            <div v-if="battery.min">
              <span class="gray4"> {{ $t("min_batt") }}</span>
              <span>{{ battery.min }}%</span>
            </div>
            <div v-if="battery.min">
              <span class="gray4"> {{ $t("max_batt") }}</span>
              <span>{{ battery.max }}%</span>
            </div>
          </div>

          <div class="step__3--card">
            <div>
              <span class="gray4"> {{ $t("geo-in") }}</span>
              <span>{{ geofenceInStatus }}</span>
            </div>
            <div>
              <span class="gray4"> {{ $t("geo-out") }}</span>
              <span>{{ geofenceOutStatus }}</span>
            </div>
            <div>
              <span class="gray4"> {{ $t("poi-in") }}</span>
              <span>{{ poiInStatus }}</span>
            </div>
            <div>
              <span class="gray4"> {{ $t("poi-out") }}</span>
              <span>{{ poiOutStatus }}</span>
            </div>
          </div>
        </div>
        <div class="step-3-col">
          <div class="d-flex justify-content-between">
            <h3 class="step-3-heading">{{ $t("devices_or_users") }}</h3>
            <span @click="$emit('step', 2)">
              <AlarmEditIcon />
            </span>
          </div>
          <div class="col-12 overflow-auto" style="max-height: 350px">
            <div class="accordion" id="accordionExample">
              <div
                class="rounded-0"
                v-for="(item, index) in accordionItems.filter(
                  (item) => item.data.length > 0
                )"
                :key="index"
              >
                <div
                  class="header p-3 p-md-4 cursor-pointer"
                  @click="toggleAccordion(index)"
                  :class="{
                    'data-table-bg': index % 2 == 0,
                  }"
                >
                  <div class="row">
                    <div class="col-7 col-sm-8 col-md-10 mb-0">
                      {{ item.title }}
                    </div>
                    <div class="col-5 col-sm-4 col-md-2 mb-0">
                      <div class="d-flex align-items-center col-gap-2">
                        <p class="mb-0">{{ item.data.length }}</p>

                        <span>
                          <IconDropdownNew
                            v-if="selectedIndexes.includes(index)"
                            style="transform: rotate(180deg)"
                          />
                          <IconDropdownNew v-else />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <transition name="slide">
                  <div v-if="selectedIndexes.includes(index)">
                    <table class="w-100">
                      <thead class="">
                        <tr>
                          <th
                            class="p-3"
                            v-for="(column, index) in item.tableColumn"
                            :key="index"
                          >
                            {{ column[0] }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(column, index) in item.data" :key="index">
                          <td class="p-3">
                            {{ column.name }}
                          </td>
                          <td v-if="column.tag" class="p-3">
                            {{ column.tag }}
                          </td>
                          <td class="p-3">
                            <span
                              class="cursor-pointer"
                              @click="
                                item.type === 'level'
                                  ? removeLevelUserByIndex(
                                      item.levelIndex,
                                      index
                                    )
                                  : handleTableClick(item.type, index)
                              "
                            >
                              <IconDeleteUser />
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </transition>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-4">
        <div
          class="d-flex align-items-center justify-content-end col-gap-1 w-100"
        >
          <button
            @click="$emit('goBack')"
            class="btn btn-secondary"
            type="button"
          >
            {{ $t("back-") }}
          </button>
          <button
            class="btn btn-primary"
            type="submit"
            :disabled="!atLeastOneAlarmType"
          >
            {{ step === 3 ? $t("done") : $t("next") }}
          </button>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ComboBox from "../../components/ComboBox.vue";
import AlarmEditIcon from "../../components/Iconsvg/AlarmEditIcon.vue";
import IconDeleteUser from "../../components/Iconsvg/IconDeleteUser.vue";
import IconDropdownNew from "../../components/Iconsvg/IconDropdownNew.vue";
import LoadingPlugin from "vue-loading-overlay";
import SuccessModal from "../Modals/SuccessModal.vue";
export default {
  name: "AddAlarm",
  props: {
    step: Number,
  },
  computed: {
    ...mapGetters(["alarms", "profile", "devices", "users", "geofence", "POI"]),
    atLeastOneAlarmType() {
      const alarmsTpesVals = [
        this.temperature.min,
        this.battery.min,
        this.humidity.min,
        this.lux.min,
        this.geofenceData.id,
        this.poiData.id,
      ];
      return (
        alarmsTpesVals.some((value) => !!value || value === 0) && this.title
      );
    },
    getDelayUnit() {
      console.log(this.delayValue, "del");
      if (this.delay === "frequency") return this.delayValue;
      const selectedTimeInterval = this.timeInterval.find(
        ({ value }) => value === this.delayValue
      );
      return selectedTimeInterval.label;
      // delay === "freq" ? "" : delayValue < 30 ? delayVal : "mins"
    },
    getDelayOptions() {
      if (this.delay === "time") return this.timeInterval;
      if (this.delay === "frequency") return this.frequencyOptions;

      return [];
    },

    accordionItems() {
      const arrayOfLevels = this.levels.map((level, index) => ({
        title: `Level ${index + 1} users`,
        data: level.levelselectedusers.map(({ name, value }) => ({
          name,
          action: value,
        })),
        tableColumn: [
          [this.$t("email-or-phone"), "name"],
          [this.$t("action"), "action"],
        ],
        type: "level",
        levelIndex: index,
      }));
      console.log(arrayOfLevels);
      return [
        {
          title: "Selected Devices",
          data: this.selecteddevices.map(({ imei, deviceName, id }) => ({
            name: deviceName,
            tag: imei,
            action: id,
          })),
          tableColumn: [
            [this.$t("dev_name"), "name"],
            [this.$t("imei"), "tag"],
            [this.$t("action"), "action"],
          ],
          type: "devices",
        },
        {
          title: "Selected Users",
          data: this.selectedusers.map(({ value }) => ({
            name: value,
            action: value,
          })),
          tableColumn: [
            [this.$t("email-or-phone"), "name"],
            [this.$t("action"), "action"],
          ],
          type: "users",
        },
        ...arrayOfLevels,
      ];
    },

    selectedIntervalLabel() {
      const arrayToFindLabel =
        this.delay === "time"
          ? this.timeInterval
          : this.delay === "frequency"
          ? this.frequencyOptions
          : [];
      const selected = arrayToFindLabel.find(
        (interval) => interval.value === this.delayValue
      );
      return selected ? selected.label : "";
    },

    poiInStatus() {
      return this.poiData.notifyWhenIn ? "Yes" : "No";
    },

    poiOutStatus() {
      return this.poiData.notifyWhenOut ? "Yes" : "No";
    },

    geofenceInStatus() {
      return this.geofenceData.notifyWhenIn ? "Yes" : "No";
    },

    geofenceOutStatus() {
      return this.geofenceData.notifyWhenOut ? "Yes" : "No";
    },

    selectedGeofence() {
      return (
        this.geofence.find((data) => data.id === this.geofenceData.id) || null
      );
    },

    selectedPOI() {
      return this.POI.find((data) => data.id === this.poiData.id) || null;
    },

    getUsersForModeOfAlarm() {
      // let activeusers = this.singlegroup.users.map((user) => user.email);

      if (this.modeOfAlarm === "email") {
        return this.users.map(({ email, ...rest }) => ({
          name: email,
          value: email,
          ...rest,
        }));
      }
      return this.users.map(({ phone, fullname, ...rest }) => ({
        name: `+${phone} - ${fullname}`,
        value: phone,

        ...rest,
      }));
    },

    computedLevelToBeWatched() {
      return this.levels.map((level) => ({ ...level }));
    },
  },
  data() {
    return {
      isLoading: false,
      fullPage: false,
      sorteddevices: [],
      allSortedDevices: [],
      selecteddevices: [],

      sortedusers: [],
      allSortedUsers: [],
      selectedusers: [],

      sortedPhones: [],
      allSortedPhones: [],
      selectedPhones: [],
      webhook: "",
      selectedIndex: 0,
      show: false,
      isShow: false,
      selectedIndexes: [],
      title: "",
      temperature: {
        min: null,
        max: null,
        notifyWhenNormal: true,
      },
      humidity: {
        min: null,
        max: null,
        notifyWhenNormal: true,
      },
      battery: {
        min: null,
        max: null,
        notifyWhenNormal: true,
      },
      poiData: {
        id: "",
        notifyWhenIn: true,
        notifyWhenOut: true,
      },
      geofenceData: {
        id: "",
        notifyWhenIn: true,
        notifyWhenOut: true,
      },
      delay: "",
      timeInterval: [
        { label: "5 mins", value: 5 },
        { label: "10 mins", value: 10 },
        { label: "15 mins", value: 15 },
        { label: "30 mins", value: 30 },
        { label: "45 mins", value: 45 },
        { label: "1 hr", value: 60 },
        { label: "2 hrs", value: 120 },
        { label: "4 hrs", value: 240 },
        { label: "6 hrs", value: 360 },
        { label: "12 hrs", value: 720 },
        { label: "24 hrs", value: 1440 },
      ],
      frequencyOptions: [
        { label: 1, value: "1" },
        { label: 2, value: "2" },
        { label: 3, value: "3" },
        { label: 4, value: "4" },
        { label: 5, value: "5" },
        { label: 6, value: "6" },
        { label: 7, value: "7" },
        { label: 8, value: "8" },
        { label: 9, value: "9" },
      ],
      delayOptions: [
        { id: 1, label: "Delay by time", value: "time" },
        { id: 2, label: "Delay by frequency", value: "frequency" },
      ],
      delayValue: "",
      notifyWhenNormal: true,
      showSuccessPopup: false,
      addAlarmEscalation: false,
      modeOfAlarm: "",
      errors: [],
      levels: [],
      showLevel: false,
      modeOfAlarmOptions: [
        { label: "Email", value: "email" },
        { label: "SMS", value: "sms" },
        { label: "Whatsapp", value: "whatsapp" },
      ],
      lux: {
        max: null,
        min: null,
        notifyWhenNormal: true,
      },
    };
  },

  watch: {
    delay() {
      this.delayValue = "";
    },
    modeOfAlarm() {
      if (this.selectedusers.length > 0) this.selectedusers = [];
      if (this.errors.includes("modeOfAlarm"))
        this.errors = this.errors.filter((item) => item !== "modeOfAlarm");
    },
    selectedusers() {
      if (this.errors.includes("users"))
        this.errors = this.errors.filter((item) => item !== "users");
    },
    selecteddevices() {
      if (this.errors.includes("devices"))
        this.errors = this.errors.filter((item) => item !== "devices");
    },
    webhook() {
      if (
        (this.errors.includes("webhook") && this.validateURL(this.webhook)) ||
        this.webhook === ""
      )
        this.errors = this.errors.filter((item) => item !== "webhook");
    },
    computedLevelToBeWatched: {
      handler(newValue, oldValue) {
        // Ensure both arrays exist
        if (!oldValue || !newValue) return;

        // Iterate through the new array to find changes
        newValue.forEach((newItem) => {
          const oldItem = oldValue.find((item) => item.id === newItem.id);

          if (!oldItem) return; // Skip if the old item doesn't exist

          // Check and update "modeOfAlarm" error
          if (
            !oldItem.modeOfAlarm &&
            oldItem.errors.includes("modeOfAlarm") &&
            newItem.modeOfAlarm
          ) {
            this.updateLevelErrors(newItem.id, "modeOfAlarm");
          }

          // Check and update "time" error
          if (
            !oldItem.levelTimeInterval &&
            oldItem.errors.includes("time") &&
            newItem.levelTimeInterval
          ) {
            this.updateLevelErrors(newItem.id, "time");
          }

          // Check and update "users" error
          if (
            oldItem.levelselectedusers.length === 0 &&
            oldItem.errors.includes("users") &&
            newItem.levelselectedusers.length > 0
          ) {
            this.updateLevelErrors(newItem.id, "users");
          }
        });
      },
      deep: true,
    },
  },

  mounted() {
    console.log(this.users);
    this.sorteddevices = this.devices
      // .filter((device) => !device.group)
      .map(({ settings, ...rest }) => ({
        name: settings.name,
        settings,
        ...rest,
      }));
    this.allSortedDevices = this.sorteddevices;

    // let activeusers = this.singlegroup.users.map((user) => user.email);
    this.sortedusers = this.users
      //   .filter((user) => !activeusers.includes(user.email))
      .map(({ email, ...rest }) => ({
        name: email,
        email,
        ...rest,
      }));
    this.allSortedUsers = this.sortedusers;

    this.sortedPhones = this.users
      //   .filter((user) => !activeusers.includes(user.email))
      .map(({ phone, id, ...rest }) => ({
        name: phone,
        phone,
        phoneId: id,
        ...rest,
        id: phone,
      }));
    this.allSortedPhones = this.sortedPhones;
  },
  methods: {
    ...mapActions(["addAlarm"]),
    updateDevice(val) {
      const index = this.selecteddevices.findIndex(
        (item) => item.imei === val.imei
      );

      if (index !== -1) {
        // If the deviceTag is already in the array, remove it
        this.selecteddevices.splice(index, 1);
      } else {
        // If the deviceTag is not in the array, add it along with deviceName
        this.selecteddevices = [
          ...this.selecteddevices,
          { imei: val.imei, deviceName: val.settings.name, id: val.id },
        ];
      }
    },
    doSearch({ target: { value } }) {
      const filtered = this.allSortedDevices.filter(
        ({ settings: { name }, group }) =>
          name.toLowerCase().includes(value.toLowerCase())
      );
      this.sorteddevices = filtered;
    },
    doSearchUser({ target: { value } }) {
      //   let activeusers = this.singlegroup.users.map((user) => user.email);
      const filtered = this.users
        .filter((user) =>
          user.email.toLowerCase().includes(value.toLowerCase())
        )
        .map(({ email, ...rest }) => ({
          name: email,
          ...rest,
        }));
      this.sortedusers = filtered;
    },
    updateUser(val) {
      // const index = this.selectedusers.indexOf(val.email);
      const index = this.selectedusers.findIndex((item) => item.id === val.id);
      if (index !== -1) {
        this.selectedusers.splice(index, 1);
      } else {
        // Value here could be email or phone number depending on the alarm mode

        this.selectedusers = [
          ...this.selectedusers,
          { value: val.value, id: val.id },
        ];
      }
    },
    removeASelectedUser(id) {
      this.selectedusers = this.selectedusers.filter((item) => item.id !== id);
    },

    doSearchPhone({ target: { value } }) {
      //   let activeusers = this.singlegroup.users.map((user) => user.email);
      const filtered = this.users
        .filter((user) =>
          user.phone.toLowerCase().includes(value.toLowerCase())
        )
        .map(({ phone, ...rest }) => ({
          name: phone,
          ...rest,
          id: phone,
        }));
      this.sortedPhones = filtered;
    },
    updatePhone(val) {
      // const index = this.selectedPhones.indexOf(val.phone);
      // if (index !== -1) {
      //   this.selectedPhones.splice(index, 1);
      // } else this.selectedPhones = [...this.selectedPhones, val.phone];

      const index = this.selectedPhones.findIndex(
        (item) => item.phone === val.phone
      );

      if (index !== -1) {
        // If the deviceTag is already in the array, remove it
        this.selectedPhones.splice(index, 1);
      } else {
        // If the deviceTag is not in the array, add it along with deviceName
        this.selectedPhones = [
          ...this.selectedPhones,
          { phone: val.phone, name: val.fullname, id: val.phoneId },
        ];
      }
    },
    updateLevelUsers(user, level) {
      // find the level that needs to be updated
      const editedLevel = this.levels.find(
        (levelItem) => levelItem.id === level.id
      );

      // find the user that its checkbox is toggled
      const editedUser = editedLevel.levelselectedusers.find(
        (levelUser) => levelUser.id === user.id
      );

      // if the user is in the array, reset the level by removing the user else add the user
      if (editedUser)
        editedLevel.levelselectedusers = editedLevel.levelselectedusers.filter(
          (levelUser) => levelUser.id !== user.id
        );
      else
        editedLevel.levelselectedusers = [
          ...editedLevel.levelselectedusers,
          user,
        ];

      // find the level that needs to be updated and use the updated user obj for it
      this.levels = this.levels.map((levelItem) => {
        if (levelItem.id === level.id) return editedLevel;
        return levelItem;
      });
    },

    removeASelectedLevelUser(userId, level) {
      // find the level that needs to be updated
      const editedLevel = this.levels.find(
        (levelItem) => levelItem.id === level.id
      );

      // find the user that its checkbox is toggled
      editedLevel.levelselectedusers = editedLevel.levelselectedusers.filter(
        (levelUser) => levelUser.id !== userId
      );

      // find the level that needs to be updated and use the updated user obj for it
      this.levels = this.levels.map((levelItem) => {
        if (levelItem.id === level.id) return editedLevel;
        return levelItem;
      });
    },
    selectAllUsersForLevel(level) {
      // find the level that all its users need to be selected
      const editedLevel = this.levels.find(
        (levelItem) => levelItem.id === level.id
      );

      // set the level's selected user to all users
      editedLevel.levelselectedusers = this.getUsersForLevel(level);

      // find the level that all its users need to be selected and set the selected users to the edited version

      this.levels = this.levels.map((levelItem) => {
        if (levelItem.id === level.id) return editedLevel;
        return levelItem;
      });
    },
    deSelectAllUsersForLevel(level) {
      // find the level that all its users need to be selected
      const editedLevel = this.levels.find(
        (levelItem) => levelItem.id === level.id
      );

      // set the level's selected user to all users
      editedLevel.levelselectedusers = [];

      // find the level that all its users need to be selected and set the selected users to the edited version
      console.log(editedLevel, "edited level");
      this.levels = this.levels.map((levelItem) => {
        if (levelItem.id === level.id) return editedLevel;
        return levelItem;
      });
    },
    getUsersForLevel(levelArg) {
      const level = this.levels.find(
        (levelItem) => levelItem.id === levelArg.id
      );
      console.log(level, "users for level");
      if (!level) return [];

      if (level.modeOfAlarm === "email") {
        return this.users.map(({ email, ...rest }) => ({
          name: email,
          value: email,
          ...rest,
        }));
      }

      return this.users.map(({ phone, fullname, ...rest }) => ({
        name: `+${phone} - ${fullname}`,
        value: phone,
        ...rest,
      }));
    },

    removeLevel(levelId) {
      this.levels = this.levels.filter((level) => level.id !== levelId);

      if (this.levels.length === 0) this.showLevel = false;
    },
    handleLevelInput(event, level) {
      // find the level that its input field is changing
      const changedLevel = this.levels.find(
        (levelItem) => levelItem.id === level.id
      );
      const { value, name } = event.target;

      // check if the mode of alram is being changed or the time interval
      if (name === "mode-of-alarm") {
        changedLevel.modeOfAlarm = value;
      }

      if (name === "time-interval") {
        changedLevel.levelTimeInterval = value;
      }
      changedLevel.levelselectedusers = [];
      // reset the level with the updated value

      this.levels = this.levels.map((levelItem) => {
        if (levelItem.id === level.id) return changedLevel;
        return levelItem;
      });
    },
    handleShowLevel(event) {
      this.levels = [];
      if (event.target.checked) {
        this.addLevel();
      }
      this.showLevel = event.target.checked;
    },
    removeLevelUserByIndex(levelIndex, userIndex) {
      const newLevel = this.levels[levelIndex];
      console.log(levelIndex, newLevel, "test");

      newLevel.levelselectedusers = newLevel.levelselectedusers.filter(
        (_, i) => i !== userIndex
      );

      if (newLevel.levelselectedusers.length > 0)
        this.levels = this.levels.map((levelItem, index) => {
          if (index === levelIndex) return newLevel;
          return levelItem;
        });
      else this.levels = this.levels.filter((_, index) => levelIndex !== index);
    },

    addLevel() {
      const levelDetails = {
        modeOfAlarm: "",
        levelTimeInterval: "",
        levelselectedusers: [],
        errors: [],
        id:
          this.levels.length === 0
            ? 1
            : this.levels[this.levels.length - 1].id + 1,
      };

      this.levels.push(levelDetails);
    },
    toggleAccordion(index) {
      // this.selectedIndex = this.selectedIndex === index ? -1 : index;
      if (this.selectedIndexes.includes(index)) {
        this.selectedIndexes = this.selectedIndexes.filter(
          (idx) => idx !== index
        );
      } else this.selectedIndexes = [...this.selectedIndexes, index];
    },
    validateURL(string) {
      try {
        new URL(string);
        return true; // If it doesn't throw, it's a valid URL
      } catch (err) {
        return false;
      }
    },
    updateLevelErrors(id, errorToRemove) {
      this.levels = this.levels.map((level) => {
        if (level.id === id) {
          return {
            ...level,
            errors: level.errors.filter((err) => err !== errorToRemove),
          };
        }
        return level;
      });
    },
    goNext() {
      if (this.step === 2) {
        console.log(this.errors);
        if (
          this.selecteddevices.length === 0 &&
          !this.errors.includes("devices")
        ) {
          this.errors.push("devices");
        }
        if (!this.modeOfAlarm && !this.errors.includes("modeOfAlarm")) {
          this.errors.push("modeOfAlarm");
        }
        if (this.selectedusers.length === 0 && !this.errors.includes("users")) {
          this.errors.push("users");
        }
        if (
          this.webhook !== "" &&
          !this.validateURL(this.webhook) &&
          !this.errors.includes("webhook")
        ) {
          this.errors.push("webhook");
        }
        if (this.levels.length > 0 && this.showLevel) {
          const uncompletedLevels = this.levels
            .filter(
              (level) =>
                !level.levelTimeInterval ||
                !level.modeOfAlarm ||
                level.levelselectedusers.length === 0
            )
            .map((level) => level.id);
          if (uncompletedLevels.length > 0) {
            this.levels = this.levels.map((level) => {
              if (uncompletedLevels.includes(level.id)) {
                let levelErrors = [];
                if (!level.levelTimeInterval) levelErrors.push("time");
                if (!level.modeOfAlarm) levelErrors.push("modeOfAlarm");
                if (level.levelselectedusers.length === 0)
                  levelErrors.push("users");
                return {
                  ...level,
                  errors: levelErrors,
                };
              }
              return level;
            });
            if (!this.errors.includes("level")) this.errors.push("level");

            console.log(this.errors);
          } else {
            if (this.errors.includes("level"))
              this.errors = this.errors.filter((item) => item !== "level");
          }
        }
        if (this.errors.length > 0) return;
      }
      if (this.step === 3) {
        const selectedUsersIds = this.selectedusers.map(({ id }) => id);
        const payload = {
          title: this.title,
          devices: this.selecteddevices.map(({ id }) => id),
          temperature:
            (this.temperature.min ?? null) !== null
              ? this.temperature
              : undefined,
          humidity:
            (this.humidity.min ?? null) !== null ? this.humidity : undefined,
          light: (this.lux.min ?? null) !== null ? this.lux : undefined,
          battery:
            (this.battery.min ?? null) !== null ? this.battery : undefined,
          notifyWhenNormal: true,
          poi: this.poiData.id ? this.poiData : undefined,
          geofence: this.geofenceData.id ? this.geofenceData : undefined,
          delay: {
            by: this.delay ?? undefined,

            value: this.delayValue ?? undefined,
          },
          notify: {
            phoneUsers:
              this.modeOfAlarm === "sms" && selectedUsersIds?.length > 0
                ? selectedUsersIds
                : undefined,
            emailUsers:
              this.modeOfAlarm === "email" && selectedUsersIds?.length > 0
                ? selectedUsersIds
                : undefined,
            whatsAppUsers:
              this.modeOfAlarm === "whatsapp" && selectedUsersIds?.length > 0
                ? selectedUsersIds
                : undefined,
            webhookURL: this.webhook ? this.webhook : undefined,
          },
          escalationTree:
            this.levels.length > 0 && this.showLevel
              ? this.levels.map((alarmLevel) => {
                  return {
                    mode: alarmLevel.modeOfAlarm,
                    interval: Number(alarmLevel.levelTimeInterval),
                    level: alarmLevel.levelselectedusers.map((user) => user.id),
                  };
                })
              : undefined,
        };

        this.isLoading = true;
        this.addAlarm(payload)
          .then(() => {
            this.isLoading = false;
            this.$emit("step", 1);
            this.$emit("closeAddAlarm");
            this.showSuccessPopup = true;
            console.log("done");
          })
          .catch((error) => {
            this.isLoading = false;
            if (error.response) {
              //console.log(error.response.data.message);
            }
          });
      } else this.$emit("goNext");
    },
    handleTableClick(type, i) {
      switch (type) {
        case "devices":
          this.selecteddevices.splice(i, 1);
          break;
        case "users":
          this.selectedusers.splice(i, 1);
          break;
        // case "level":
        //   this.updateLevelUsersByIndex.splice(i, 1);
        // break;
        default:
          break;
      }
    },
    isRequiredField(val) {
      return val === 0 || !!val;
    },
    closeSuccess() {
      this.showSuccessPopup = false;
      setTimeout(() => {
        this.$router.push("/alarms");
      }, 300);
    },
  },
  components: {
    ComboBox,
    IconDeleteUser,
    IconDropdownNew,
    AlarmEditIcon,
    LoadingPlugin,
    SuccessModal,
  },
};
</script>

<style scoped>
p {
  margin-bottom: 0;
}
.step-3 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  justify-content: space-between;
  align-items: flex-start;
  gap: 40px;
}
.step-3-col {
  flex-basis: 40%;
}
.step__3--card {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  background: #f6f8fc;
  border-radius: 16px;
  padding: 16px;
}
.step__3--card > div {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
/* #8693A5 */
.step-3-heading {
  font-size: 18px;
  font-weight: 500;
}

.grid-card {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}
.level-checkbox,
.levels {
  grid-column: span 2;
}
.level-row {
  display: grid;
  grid-template-columns: 1fr 1fr 50px;
  gap: 10px;
  width: 100%;
  align-items: start;
}
.line-divider {
  width: 100%;
  height: 1px;
  background-color: #0000001a;
}
.level-checkbox {
  display: flex;
  align-items: center;
}
.level-checkbox label {
  margin-bottom: 0px;
  margin-left: 5px;
}
/* .step-3 .card {
  border-radius: 12px;
  background: #fff;

  /* Style 2 */
/* box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.08); */
/* } */

/* .slide-enter-active,
.slide-leave-active {
  transition: max-height 3.5s;
}
.slide-enter-from {
  max-height: 0;
}
.slide-leave-to {
  max-height: 100px;
}

.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
} */

ul,
svg {
  cursor: pointer;
}

.delete {
  color: #dc3030;
  background: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #dc3030;
  padding: 5px;
  border-radius: 5px;
  width: 20px;
  height: 20px;
  align-self: center;
  cursor: pointer;
}
.move-up {
  transform: translateY(-10px);
}
.add-header {
  color: #404a57;
}
.add-btn:focus,
.add-btn:active {
  border: 0px;
  outline: 0px;
}

.add-btn {
  background: transparent;
  color: #213e7a;
  border: 0px;
  font-size: 14px;
  width: 90px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.add-btn span:first-child {
  font-size: 20px;
  transform: translateY(-2px);
}
.add-header {
  color: #404a57;
}
.slide-enter-active {
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -moz-transition-timing-function: ease-in;
  -webkit-transition-timing-function: ease-in;
  -o-transition-timing-function: ease-in;
  transition-timing-function: ease-in;
}

.slide-leave-active {
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-enter-to,
.slide-leave {
  max-height: 100px;
  overflow: hidden;
}

.slide-enter,
.slide-leave-to {
  overflow: hidden;
  max-height: 0;
}

.alarm_value {
  /* border: 2px solid red; */
  display: flex;
  justify-content: space-between;
}

.alarm_value > .text {
  color: rgba(134, 147, 165, 1);
  font-weight: 400;
  font-size: 14px;
}

/*@media (min-width: 768px) {
  .add-alarm {
    padding: 1rem;
  }
}

@media (min-width: 1600px) {
    .add-alarm {
    padding: 2rem;
  }
}*/
</style>
